/**
 * Таби меню ресторану.
 *
 * Панелі й таби звʼязані через data-panel (id панелі) — тому блок може
 * містити скільки завгодно категорій, і нічого не треба хардкодити.
 */
export default function menuTabs() {
	const tabs = document.querySelectorAll('.tab[data-panel]');
	if (!tabs.length) return;

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			const panelId = tab.dataset.panel;

			// Скидаємо всі таби/панелі лише в межах ЦЬОГО блока, а не на всій
			// сторінці — інакше два меню на одній сторінці гасили б одне одного.
			const block = tab.closest('.menu__wrap') || document;

			block.querySelectorAll('.tab[data-panel]').forEach((t) => {
				t.setAttribute('aria-selected', 'false');
			});
			block.querySelectorAll('.menu-list[data-panel]').forEach((p) => {
				p.classList.remove('is-active');
			});

			tab.setAttribute('aria-selected', 'true');

			const panel = block.querySelector(`.menu-list[data-panel="${panelId}"]`);
			if (panel) panel.classList.add('is-active');
		});
	});
}
